'use client';

import { Suspense, type ReactNode } from 'react';
import SustainabilityLanding from '../components/SustainabilityLanding';
import SustainabilityLandingSkeleton from '../components/SustainabilityLandingSkeleton';
import type { TransformedSustainabilityData } from '@/types/sustainability';

interface SustainabilityLandingClientProps {
  locale: string;
  landingData: TransformedSustainabilityData | null;
  /**
   * Streaming slot for the FAQ + enquiry block at the page bottom. The
   * lead-forms Strapi fetch happens in an async Server Component over
   * in `page.tsx` and is wrapped in `<Suspense>`, so above-fold content
   * paints without waiting on it.
   */
  faqSlot?: ReactNode;
}

export default function SustainabilityLandingClient({
  locale,
  landingData,
  faqSlot,
}: SustainabilityLandingClientProps) {
  return (
    <Suspense fallback={<SustainabilityLandingSkeleton />}>
      <SustainabilityLanding locale={locale} landingData={landingData} faqSlot={faqSlot} />
    </Suspense>
  );
}
